export default "__VITE_ASSET__BjGCURuy__"